var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10326 0.816985C7.47008 0.0737391 8.52992 0.07374 8.89674 0.816986L10.4124 3.88798C10.558 4.18313 10.8396 4.38769 11.1653 4.43502L14.5543 4.92748C15.3746 5.04667 15.7021 6.05464 15.1086 6.63317L12.6562 9.02361C12.4205 9.25335 12.313 9.58435 12.3686 9.90874L12.9475 13.2841C13.0877 14.101 12.2302 14.724 11.4966 14.3383L8.46534 12.7446C8.17402 12.5915 7.82598 12.5915 7.53466 12.7446L4.5034 14.3383C3.76978 14.724 2.91235 14.101 3.05246 13.2841L3.63137 9.90874C3.68701 9.58435 3.57946 9.25335 3.34378 9.02361L0.89144 6.63317C0.297923 6.05464 0.625434 5.04667 1.44565 4.92748L4.8347 4.43502C5.16041 4.38769 5.44197 4.18313 5.58764 3.88798L7.10326 0.816985Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.664e71ef.svg";
export { ForwardRef as ReactComponent };